import { render, staticRenderFns } from "./ComboCombination.vue?vue&type=template&id=502b7b84&scoped=true&"
import script from "./ComboCombination.vue?vue&type=script&lang=js&"
export * from "./ComboCombination.vue?vue&type=script&lang=js&"
import style0 from "./ComboCombination.vue?vue&type=style&index=0&id=502b7b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b7b84",
  null
  
)

export default component.exports